export default "__VITE_ASSET__B7m$a8KB__"